import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import MonsterWalkPassword from '../MonsterWalkPassword/MonsterWalkPassword';

function MonsterWalkApp() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/password-recovery" element={<MonsterWalkPassword />} />
        <Route path="/monsterwalk-password-recovery" element={<MonsterWalkPassword />} />
        <Route path="/" element={<Navigate to="/password-recovery" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default MonsterWalkApp;